module.exports = __webpack_public_path__ + "img/ic_empathy@2x.7053e4f9.png";